{
  "kind": {
    "guest": "Guest (no account)",
    "registered": "Has an account"
  },
  "columns": {
    "name": "Name",
    "email": "E-mail",
    "phone": "Phone",
    "kind": "Account",
    "locale": "Language",
    "tags": "Tags",
    "marketing": "News by e-mail",
    "last_seen": "Last seen",
    "created": "Since",
    "state": "State"
  },
  "locales": {
    "en": "English",
    "ja": "日本語",
    "th": "ไทย",
    "zh_Hant": "繁體中文",
    "zh_Hans": "简体中文"
  },
  "marketing": {
    "yes": "Yes",
    "no": "No"
  },
  "state": {
    "merged": "Merged into another account",
    "closed": "Closed",
    "open": "Open"
  },
  "filters": {
    "q": "Search",
    "q_placeholder": "Name, カナ or e-mail",
    "closed": "Also closed / merged accounts"
  },
  "list": {
    "intro": "Everyone who bought — with an account or as a guest. Tap a row for orders, store credit and merging duplicates.",
    "intro_limited": "Your role sees the customer's name and the last 4 digits of the phone."
  },
  "detail": {
    "back": "All customers",
    "load_failed": "The customer could not be opened",
    "orders": "Orders (web and shop)",
    "no_orders": "No orders with this e-mail yet.",
    "orders_hint": "Orders are found by the customer's e-mail.",
    "consents": "Agreements (privacy)",
    "no_consents": "No agreements recorded.",
    "merged_into": "Open the account it was merged into",
    "limited": "Your role sees the name and the last 4 digits of the phone. Ask a manager for more.",
    "profile": "Details",
    "email_verified": "E-mail confirmed",
    "profile_hint": "The customer changes these on the website (My account)."
  },
  "consent": {
    "privacy": "Privacy policy",
    "terms": "Terms of sale",
    "marketing": "News by e-mail",
    "cross_border": "Data stored abroad",
    "accepted": "Agreed",
    "declined": "Declined"
  },
  "credit": {
    "title": "Store credit",
    "issue": "Give credit",
    "issue_title": "Give store credit",
    "issue_description": "The customer can pay with it at the shop and on the website until the last day.",
    "issue_confirm": "Give the credit",
    "issued": "{{amount}} store credit given",
    "issued_hint": "Usable until {{day}}.",
    "amount": "Amount",
    "reason": "Why",
    "reason_placeholder": "e.g. Sorry for the late parcel",
    "kind": "Did the customer pay for it?",
    "paid_for": "Yes — instead of money (refund, buying cards)",
    "free": "No — a gift from the shop",
    "last_day": "Last day",
    "last_day_hint": "At most until {{day}}: longer credit would fall under the Payment Services Act (資金決済法).",
    "blocker": {
      "amount": "Type the amount in whole yen.",
      "reason": "Write why.",
      "day_after_max": "Store credit may be used for at most 6 months — choose {{day}} or earlier (資金決済法).",
      "day_past": "The last day cannot be in the past.",
      "day_invalid": "Choose a day."
    },
    "load_failed": "The store credit could not be loaded",
    "paid_for_balance": "Paid for:",
    "free_balance": "Gift:",
    "next_expiry": "Ends next:",
    "lots": "Credit given",
    "col": {
      "given": "Given",
      "amount": "Amount",
      "left": "Left",
      "last_day": "Last day",
      "reason": "Why"
    },
    "expired": "Ended",
    "paid_for_short": "paid for",
    "free_short": "gift",
    "none": "No store credit yet.",
    "history": "History",
    "entry": {
      "issue": "Given",
      "redeem": "Used",
      "expire": "Ended",
      "refund_in": "Given back from a refund",
      "adjust": "Corrected",
      "reverse": "Taken back"
    },
    "law": "Store credit is valid for 6 months at most (資金決済法) and cannot be paid out in cash."
  },
  "merge": {
    "open": "Merge a duplicate",
    "title": "Merge two accounts of the same person",
    "description": "Find the other account, choose which one stays, check what happens, then confirm.",
    "search": "Find the other account",
    "search_hint": "Name or e-mail.",
    "which": "Which account is the same person?",
    "none": "No other account found.",
    "choose": "Choose the other account first.",
    "stays": "Which account stays?",
    "keep": "Stays",
    "close": "Is closed",
    "next": "Check and merge",
    "effect_addresses": "Addresses and sign-ins move to {{name}}.",
    "effect_closed": "{{email}} is closed.",
    "effect_search": "Searching {{email}} later finds {{name}}.",
    "effect_orders": "Orders keep their customer details.",
    "confirm_title": "Merge these accounts?",
    "confirm_consequence": "{{close}} is closed and its details move to {{keep}}. This cannot be undone.",
    "confirm": "Merge",
    "done": "Merged — {{name}} stays",
    "done_hint": "{{addresses}} address(es) moved."
  },
  "dsar": {
    "title": "Customer's data (privacy law)",
    "body": "When a customer asks for a copy of their data or asks to delete it, record the request here. The system collects the answer from every part of the shop.",
    "export": "Copy of the data",
    "delete": "Delete the data",
    "export_title": "Make a copy of this customer's data?",
    "export_consequence": "The customer gets a download link by e-mail. Write how you checked it is really them.",
    "delete_title": "Delete this customer's data?",
    "delete_consequence": "Data the law makes the shop keep (receipts, 古物台帳) stays. Write how you checked it is really them.",
    "done_export": "Data copy asked for",
    "done_delete": "Deletion asked for",
    "done_hint": "It is finished within the legal time; you get a notice."
  }
}
